import { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import InformationToolTip from "../../../../common/components/InformationToolTip";
import StoreIcon from '@mui/icons-material/Store';
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import Inventory2Icon from '@mui/icons-material/Inventory2';

export default function StoreArticleZeroSalesToolTip() {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        const clearToolTipOnScroll = () => {
            // Close the tooltip when scrolling
            setTooltipOpen(false);
        };

        window.addEventListener('scroll', clearToolTipOnScroll);
        return () => {
            window.removeEventListener('scroll', clearToolTipOnScroll);
        };
    }, []);

    const infoForTooltip = [
        {
            title: "Alarm Legends",
            section: [
                {
                    icon: <StoreIcon fontSize="medium" sx={{ color: "#EA324C" }} />,
                    title: "Store Display",
                    info: [
                        "CSL ≥ 75% OR Days Supply ≥ 45 days net of rentables.",
                    ]
                },
                {
                    icon: <Inventory2Icon fontSize="small" sx={{ color: "#F2AC42" }} />,
                    title: "Stock Problem",
                    info: [
                        "CSL ≤ 70% AND Days Supply ≤ 15 days net of rentables.",
                    ]
                },
                {
                    icon: <InventoryTwoToneIcon fontSize="small" sx={{ color: "#002060" }} />,
                    title: "Order Settings",
                    info: [
                        "CSL ≥ 75% AND Days Supply ≤ 15 days net of rentables.",

                    ]
                },
                {
                    title: "Last Received Date",
                    info: [
                        "Date of last stock received from vendor or stock transfer."
                    ]
                },
                {
                    title: "No. of Days:",
                    info: [
                        "Counts consecutive zero-sales days (3 days to 30 days).",
                        "Except for 15 days, where it means at least 12 zero-sales days within the last 15 days."
                    ]
                }
            ]
        }
    ]

    const informationContent = infoForTooltip.map((section, sectionIdx) => (
        <Box key={sectionIdx} mb={2}>
            <Typography variant="body1" fontWeight="bold" my={0.5} mt={sectionIdx === 0 ? 0 : 4}>
                {section.title}
            </Typography>
            <Divider sx={{ borderBottomWidth: '1px', backgroundColor: '#000', mb: 1 }} />
            {section.section.map((item, itemIdx) => (
                <Box key={itemIdx} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Box mr={.5}>{item.icon}</Box>
                        <Typography variant="body2" fontWeight="bold">{item.title}</Typography>
                    </Box>
                    {item.info.map((infoText, infoIdx) => (
                        <Typography variant="body2" key={infoIdx} sx={{ ml: 4, display: 'flex', alignItems: 'flex-start' }}>
                            <li>
                                {infoText}
                            </li>
                        </Typography>
                    ))}
                </Box>
            ))}
        </Box>
    ));

    const handleTooltipChange = (value) => {
        setTooltipOpen(value);
    };

    return <InformationToolTip onChange={handleTooltipChange} open={tooltipOpen} information={informationContent} />
}